export default __webpack_public_path__ + "static/media/heroFallback.6191b991.jpg";